import LendingKart from "./../../assets/images/lender/lendingkart.png"
const lendingPartners = [
    {
        id: 1,
        brandName: "Lendingkart",
        legalName: "Lendingkart Finance Limited",
        logo: LendingKart, // Import logo later
        website: "https://www.lendingkart.com/",
        kfs: "https://freedm-images.s3.ap-south-1.amazonaws.com/docs/KFS_Lendingkart_Business_Loan.xlsx",

        grievanceOfficer: {
            name: "Ketan Sali",
            designation: "Senior Manager – Customer Service",
            workingHours:
                "10:30 AM to 6:00 PM (Monday to Friday, except National Holidays)",
            contact: "+91-6358874622",
            email: "grievance.redressal@lendingkart.com",
            address:
                "4th Floor, 401, Iconic Shyamal, Nr. Shyamal Cross Road, Satellite, Ahmedabad, Gujarat - 380015",
        },

        nodalOfficer: {
            name: "Sayanendu Chatterjee",
            designation: "Principal Nodal Officer",
            companyName: "Lendingkart Finance Limited",
            contact: "+91-70690 87586",
            email: "nodalofficer@lendingkart.com",
            address:
                "Indraprasth Business Park, 6th Floor, Sarkhej Roza Road, Makarba, Ahmedabad - 380051",
        },
    },
];

export default lendingPartners;